import {NgModule} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FuseNavigationModule} from '@fuse/components/navigation';
import {FuseLoadingBarModule} from '@fuse/components/loading-bar';
import {FuseFullscreenModule} from '@fuse/components/fullscreen/fullscreen.module';
import {LanguagesModule} from 'app/layout/common/languages/languages.module';
import {MessagesModule} from 'app/layout/common/messages/messages.module';
import {NotificationsModule} from 'app/layout/common/notifications/notifications.module';
import {QuickChatModule} from 'app/layout/common/quick-chat/quick-chat.module';
import {SearchModule} from 'app/layout/common/search/search.module';
import {ShortcutsModule} from 'app/layout/common/shortcuts/shortcuts.module';
import {UserModule} from 'app/layout/common/user/user.module';
import {SharedModule} from 'app/modules/shared/shared.module';
import {ClassyLayoutComponent} from 'app/layout/layouts/vertical/classy/classy.component';
import {PageHeaderContextComponent} from 'app/layout/common/page-header-context/page-header-context.component';

@NgModule({ declarations: [
        ClassyLayoutComponent
    ],
    exports: [
        ClassyLayoutComponent
    ], imports: [PageHeaderContextComponent,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        MessagesModule,
        NotificationsModule,
        QuickChatModule,
        SearchModule,
        ShortcutsModule,
        UserModule,
        SharedModule], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class ClassyLayoutModule {
}
